var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import history from 'helpers/History';
import { Table } from 'components';
import { loading } from 'elements/Loading';
var OperationLinesTable = /** @class */ (function (_super) {
    __extends(OperationLinesTable, _super);
    function OperationLinesTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSelectItem = function (value) {
            history.push("/operationlines/".concat(value.id));
        };
        _this.handleCreate = function () {
            history.push("/operationlines/create");
        };
        _this.mapea = function (values, businessUnits) {
            return values.map(function (item) {
                var businessUnit = businessUnits.filter(function (ol) {
                    return ol.id === item.businessUnit_id;
                })[0];
                var operationLineString = 'businessUnit';
                item[operationLineString] = businessUnit ? businessUnit.name : '';
                /*const receiptLayout = receiptLayouts.filter(ol => {
                  return ol.id === item.receiptLayout_id
                })[0]
                const receiptLayoutString = 'receiptLayout'
                item[receiptLayoutString] = receiptLayout ? receiptLayout.name : ''*/
                // console.log('item', item)
                return item;
            });
        };
        return _this;
    }
    OperationLinesTable.prototype.componentDidMount = function () {
        // console.log('componentDidMount')
        // this.props.store!.operationLines.read()
        // this.props.store!.businessUnits.read()
        // this.props.store!.receipLayouts.read()
    };
    OperationLinesTable.prototype.render = function () {
        var operationLines = this.props.operationLines;
        var businessUnits = this.props.businessUnits;
        // const {receiptLayouts} = this.props
        // console.log('operationLines', operationLines)
        var mapeados = this.mapea(operationLines, businessUnits /*, receiptLayouts*/);
        var headers = ['name', 'code', 'businessUnit' /*, 'receiptLayout'*/, 'disabled_at'];
        var filters = [
            {
                name: 'all',
                filter: function (item) { return true; }
            },
            {
                name: 'actives',
                filter: function (item) { return item.disabled_at === null; }
            },
            {
                name: 'disabled',
                filter: function (item) { return item.disabled_at !== null; }
            },
        ];
        if (!(businessUnits.length > 0))
            return React.createElement("div", null,
                React.createElement("text", null, "No hay negocios dados de alta, por favor cree uno antes"),
                " ");
        return (React.createElement(Table
        /*items={operationLines.data}*/
        , { 
            /*items={operationLines.data}*/
            filters: filters, items: mapeados, header: headers, onSelectItem: this.handleSelectItem, onCreate: this.handleCreate, keyExtractor: function (item) { return String(item.id); }, loading: operationLines === undefined || businessUnits === undefined /*|| receiptLayouts===undefined*/ }));
    };
    OperationLinesTable = __decorate([
        inject('store'),
        loading(function (props) {
            return [
                props.store.operationLines.read().then(function (operationLines) { return ({ operationLines: operationLines }); }),
                props.store.businessUnits.read().then(function (businessUnits) { return ({ businessUnits: businessUnits }); }),
                // props.store!.receipLayouts.read().then(receiptLayouts => ({receiptLayouts}))
            ];
        }),
        observer
    ], OperationLinesTable);
    return OperationLinesTable;
}(Component));
export default OperationLinesTable;



//////////////////
// WEBPACK FOOTER
// ./src/modules/OperationLines/container/OperationLinesTable.tsx
// module id = 1268
// module chunks = 0